import genererEntiteCommerciale from '@/services/entiteCommerciale/genererEntiteCommerciale';
import genererEmplacementTechnique
  from '@/services/gabed/emplacement/generer/genererEmplacementTechnique';

export default function genererEmplacementLigneBus() {
  const entiteCommerciale = genererEntiteCommerciale();
  entiteCommerciale.entiteCommercialeLigneBus = {
    pointDepart: '',
    pointArrivee: '',
    nbBusCirculant: null,
  };
  return {
    emplacementTechnique: genererEmplacementTechnique(),
    entiteCommerciale: entiteCommerciale,
    code: '',
    libelle: '',
    description: '',
    societeId: '',
    agenceId: null,
    actif: true,
  };
}
